export enum PanelName {
	CommentsPanel = 'commentsPanel',
	DetailsPanel = 'detailsPanel',
	AgentReceiptPanel = 'agentReceiptPanel',
	WorkflowsPanel = 'workflowsPanel',
	SuggestionsPanel = 'suggestionsPanel',
	AutomationsPanel = 'automationsPanel',
}

const MIGRATED_PANEL_IDS: ReadonlySet<string> = new Set([
	PanelName.CommentsPanel,
	PanelName.DetailsPanel,
	PanelName.AgentReceiptPanel,
	PanelName.SuggestionsPanel,
	PanelName.AutomationsPanel,
	'jiraWorkItemsPanel',
]);

export function isMigratedToPanelSystem(panelId: string | undefined): boolean {
	return !!panelId && MIGRATED_PANEL_IDS.has(panelId);
}
